import { getRandomUniqueNumbers } from "../../../../../../src/utils/getRandomUniqueNumbers";
import { moveAllPointAnim } from "../../IntroAnimationManager/helpers/drawHelpers";


export function generateRandomlyRadians(PointManager) {
  const newRadians = getRandomUniqueNumbers(3, 0, 5).sort((a, b) => a - b);
  newRadians.map((v: number) => (v * (Math.PI / 3))).sort().reverse();
  moveAllPointAnim(PointManager, newRadians);
}